import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Text } from "@cinch-labs/design-system";
import { dashify } from "@cinch-labs/shared-util";
import { storyblokEditable } from "@cinch-nx/data-storyblok";
import { Accordion } from "@cinch-nx/shared-ui";
import renderWithResolver from "../rich-text-renderer/rich-text-renderer";
import styles from "./faq-accordion.module.css";
export var FaqAccordion = function(blok) {
    var title = blok.title, faqs = blok.faqs;
    var accordionItems = faqs.map(function(faq) {
        return {
            title: faq.title,
            children: function() {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: renderWithResolver(faq.body)
                });
            }
        };
    });
    return /*#__PURE__*/ _jsxs("section", _object_spread_props(_object_spread({
        className: styles.faqSection
    }, storyblokEditable(blok)), {
        children: [
            /*#__PURE__*/ _jsx(Text, {
                className: styles.sectionTitle,
                element: "h2",
                fontWeight: "bold",
                id: dashify(title),
                children: title
            }),
            /*#__PURE__*/ _jsx(Accordion, {
                title: title,
                items: accordionItems,
                buttonId: title,
                sectionId: "model-faq-section"
            })
        ]
    }));
};
